export default __webpack_public_path__ + "static/NeueMontreal-Bold-79b1af984b32c38321debe99c1fb53c0.woff2";